import { useEffect } from 'react';

import Logger, { LoggerOrigin } from '@/services/Logger';
import { ApiError } from '@/services/utils/ApiError';

import { SomethingWentWrong } from './general-errors/SomethingWentWrong';
import { HttpError } from './http-errors/HttpError';

interface IErrorHandlerProps {
  readonly err?: unknown;
}

export function ErrorHandler({ err }: IErrorHandlerProps) {
  useEffect(() => {
    Logger.error(LoggerOrigin.ErrorBoundaries, '', err);
  }, [err]);

  let errorComponent = null;

  if (err !== undefined && !(err instanceof Error)) {
    errorComponent = <SomethingWentWrong err={err as Error} />;
  } else if (err !== undefined && err.name === 'ApiError') {
    errorComponent = <HttpError err={err as ApiError} />;
  } else if (
    err !== undefined &&
    err.name === 'StartupableStartupError' &&
    err.cause !== undefined
  ) {
    errorComponent = <ErrorHandler err={err.cause} />;
  } else {
    errorComponent = <SomethingWentWrong err={err} />;
  }

  return <>{errorComponent}</>;
}
